var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFe40(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3319_10137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8037 25.1965L36.3268 7.65799C36.3268 7.65799 40.5548 3.56095 44.259 7.2651L54.0618 23.8869",
    stroke: "black",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8211 39.75V37.6187L34.1648 29.2H36.0023V32.15H34.9148L31.5461 37.4812V37.5812H39.1398V39.75H28.8211ZM34.9648 42V39.1L35.0148 38.1562V29.2H37.5523V42H34.9648ZM45.9617 42.2813C44.8867 42.2771 43.9617 42.0125 43.1867 41.4875C42.4159 40.9625 41.8221 40.2021 41.4055 39.2062C40.993 38.2104 40.7888 37.0125 40.793 35.6125C40.793 34.2167 40.9992 33.0271 41.4117 32.0437C41.8284 31.0604 42.4221 30.3125 43.193 29.8C43.968 29.2833 44.8909 29.025 45.9617 29.025C47.0326 29.025 47.9534 29.2833 48.7242 29.8C49.4992 30.3167 50.0951 31.0667 50.5117 32.05C50.9284 33.0292 51.1346 34.2167 51.1305 35.6125C51.1305 37.0167 50.9221 38.2167 50.5055 39.2125C50.093 40.2083 49.5013 40.9687 48.7305 41.4937C47.9596 42.0187 47.0367 42.2813 45.9617 42.2813ZM45.9617 40.0375C46.6951 40.0375 47.2805 39.6687 47.718 38.9312C48.1555 38.1937 48.3721 37.0875 48.368 35.6125C48.368 34.6417 48.268 33.8333 48.068 33.1875C47.8721 32.5417 47.593 32.0562 47.2305 31.7312C46.8721 31.4062 46.4492 31.2437 45.9617 31.2437C45.2326 31.2437 44.6492 31.6083 44.2117 32.3375C43.7742 33.0667 43.5534 34.1583 43.5492 35.6125C43.5492 36.5958 43.6471 37.4167 43.843 38.075C44.043 38.7292 44.3242 39.2208 44.6867 39.55C45.0492 39.875 45.4742 40.0375 45.9617 40.0375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0766 78V65.2H39.5516V67.4312H33.7828V70.4812H38.9891V72.7125H33.7828V78H31.0766ZM41.3719 78V65.2H49.9969V67.4312H44.0781V70.4812H49.5531V72.7125H44.0781V75.7687H50.0219V78H41.3719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2564 55.9971L16.8061 55.6531C16.8061 55.6531 11.1439 54.04 12.4997 48.9801L21.9932 32.1797",
    stroke: "black",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2048 30.6758L68.1321 48.5583C68.1321 48.5583 69.5662 54.2684 64.5063 55.6242L45.21 55.8028",
    stroke: "black",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3418 55.8543L49.0777 48.9414V62.5529L37.3418 55.8543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3027 32.2137L26.0387 25.3008V38.9123L14.3027 32.2137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3223 23.9872L58.0582 17.0742V30.6857L46.3223 23.9872Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3319_10137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFe40);
export default __webpack_public_path__ + "static/media/fe40.ccc117e98c4c15bf007bd279c505a273.svg";
export { ForwardRef as ReactComponent };